import { computedFrom, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { WidgetData } from 'support/base_classes/widget-base';

@customElement('as-widget-container')
export class WidgetContainer {
  @bindable kind: string;
  @bindable model: unknown;
  @bindable disabled = false;
  @bindable index: number = null;
  controller: WidgetController = null;

  @computedFrom('kind')
  get path() {
    return `widgets/${this.kind}`;
  }

  @computedFrom('model')
  get data(): WidgetData<unknown, WidgetController> {
    return { model: this.model, controller: this.controller ?? (this.controller = new WidgetController(this, this.disabled, this.index)) };
  }

  disabledChanged(value: boolean) {
    if (this.controller != null) this.controller.disabled = value;
  }

  indexChanged(value: number) {
    if (this.controller != null) this.controller.index = value;
  }
}

export class WidgetController {
  constructor(private container: WidgetContainer, public disabled: boolean, public index: number) { }
}
